import { render, staticRenderFns } from "./FooterHelloteca.vue?vue&type=template&id=6e9e3013&scoped=true"
var script = {}
import style0 from "./FooterHelloteca.vue?vue&type=style&index=0&id=6e9e3013&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9e3013",
  null
  
)

export default component.exports